import { AnswerLifestyleQuestion } from "$gql/mutations/general/AnswerLifestyleQuestion.gen";
import { SkipLifestyleQuestion } from "$gql/mutations/general/SkipLifestyleQuestion.gen";
import { GetUserLifestyleQuestions } from "$gql/queries/general/GetUserLifestyleQuestions.gen";
import LoadingBlock from "components/Loading/LoadingBlock";
import { useCallback, useState } from "react";
import { useMutationBundle, useQueryBundle } from "source/hooks";
import { LifestyleQuestion } from "./LifestyleQuestion";

interface Props {
  userId: number;
  tickerSymbol?: string;
  questionLayout?: "grid" | "stack";
}

export const LifestyleQuestions: React.FC<Props> = (props) => {
  const [answeredQuestions, setAnsweredQuestions] = useState<string[]>([]);
  const [skipQuestionMutation] = useMutationBundle(SkipLifestyleQuestion);
  const [answerQuestionMutation] = useMutationBundle(AnswerLifestyleQuestion);

  const onSelect = useCallback(
    (questionId: string, option: string) => {
      answerQuestionMutation({
        variables: {
          questionId,
          userId: props.userId,
          answer: option,
        },
      }).then(() => {
        setAnsweredQuestions([...answeredQuestions, questionId]);
      });
    },
    [answerQuestionMutation, answeredQuestions]
  );

  const onSkipQuestion = useCallback(
    (questionId: string) => {
      skipQuestionMutation({
        variables: {
          userId: props.userId,
          questionId,
        },
      }).then(() => {
        setAnsweredQuestions([...answeredQuestions, questionId]);
      });
    },
    [skipQuestionMutation, answeredQuestions]
  );

  const answeredOrSkipped = useQueryBundle(GetUserLifestyleQuestions, {
    variables: { userId: props.userId },
  });

  if (answeredOrSkipped.state !== "DONE") {
    return <LoadingBlock />;
  }

  const excludeIds = answeredOrSkipped.data.getLifestyleQuestionsForUser
    .map((q) => q.questionId)
    .concat(answeredQuestions);

  return (
    <LifestyleQuestion
      userId={props.userId}
      excludedQuestionIds={excludeIds}
      tickerSymbol={props.tickerSymbol}
      onSelect={onSelect}
      onSkipQuestion={onSkipQuestion}
      layout={props.questionLayout}
    />
  );
};
